import { render, staticRenderFns } from "./UserNumberPack.vue?vue&type=template&id=5fd9753a&scoped=true"
import script from "./UserNumberPack.vue?vue&type=script&lang=js"
export * from "./UserNumberPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9753a",
  null
  
)

export default component.exports